module.exports = require("@swa-ui/placements/src/ContentSection/ContentSection.module.scss");